//#region src/types/define-literal.ts
function defineLiteral(value) {
	return value;
}
function defineValue(value) {
	return value;
}
//#endregion
export { defineLiteral, defineValue };

//# sourceMappingURL=define-literal.js.map